// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button {
  border: 0;
  border-radius: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 500;
}
.Button.black-btn {
  background-color: #000;
  color: #fff;
}
.Button.yellow-btn {
  background-color: #ebff0c;
  color: #000;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}
.Button.blue-btn {
  background-color: #3881ef;
  color: #fff;
}
.Button.red-btn {
  background-color: #ef3838;
  color: #fff;
}
.Button.red-disable-btn {
  background-color: #ef3838;
  color: #fff;
  opacity: 0.5;
  font-weight: 600;
  border-radius: 5px;
  height: 45px !important;
  font-size: 15px !important;
  margin-top: 0px;
}
.Button.warning-red-btn {
  background-color: #ef3838;
  color: #fff;
  font-weight: 600;
  border-radius: 5px;
  height: 45px !important;
  font-size: 15px !important;
  margin-top: 0px;
}
.Button.link-blue-btn {
  background-color: inherit;
  font-weight: 500;
  color: #3881ef;
}
.Button.outline-grey-btn {
  border: 1px solid #848b94;
  color: #848b94;
  background-color: inherit;
}
.Button.fullWidth {
  width: 100%;
}
.Button.large-btn {
  font-size: 20px;
  height: 63px;
  padding-left: 25px;
  padding-right: 25px;
}
.Button.small-btn {
  font-size: 14px;
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
}
.Button.grey-btn {
  background-color: #f1f4f9;
  color: #000;
}
.Button.dark-grey-btn {
  background-color: #d5dce7;
  color: #000;
}
.Button.white-btn {
  background-color: #fff;
  color: #000;
}
.Button.white-link-btn {
  background-color: inherit;
  border: 0;
  color: #fff;
}
.Button.white-blue-btn {
  background-color: #fff;
  color: #3881ef;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}
.Button.extra-small-btn {
  font-size: 10px;
  padding-left: 7px;
  padding-right: 7px;
  margin-top: 0;
  margin-bottom: 0;
}
.Button.link-btn {
  color: #848b94;
  background-color: inherit;
}
.Button.blue-link-btn {
  color: #3881ef;
  background-color: inherit;
}
.Button.link-decoration-btn {
  background-color: inherit;
  font-weight: 500;
  color: #3881ef;
  text-decoration-line: underline;
  text-decoration-color: #3881ef;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .Button.small-btn {
    padding-left: 9px !important;
    padding-right: 9px !important;
  }
  .Button.large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
  }
}
@media screen and (max-width: 435px) {
  Button.large-btn {
    height: 48px !important;
  }
}
@media screen and (max-width: 575px) {
  .Button.small-btn {
    height: 37px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 820px) {
  .Button.small-btn {
    font-size: 13px !important;
  }
}
@media screen and (min-width: 821px) and (max-width: 1200px) {
  .Button.small-btn {
    font-size: 11px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/Button/Button.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,sBCRI;EDSJ,WCRI;ADOR;AAIE;EACE,yBCXK;EDYL,WCdI;EDeJ,yCAAA;AAFJ;AAKE;EACE,yBChBG;EDiBH,WCnBI;ADgBR;AAME;EACE,yBCnBE;EDoBF,WCxBI;ADoBR;AAOE;EACE,yBCxBE;EDyBF,WC7BI;ED8BJ,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;AALJ;AAQE;EACE,yBCnCE;EDoCF,WCxCI;EDyCJ,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;AANJ;AASE;EACE,yBAAA;EACA,gBAAA;EACA,cCjDG;AD0CP;AAUE;EACE,yBAAA;EACA,cChDI;EDiDJ,yBAAA;AARJ;AAWE;EACE,WAAA;AATJ;AAYE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,yBCzEI;ED0EJ,WCjFI;ADqER;AAeE;EACE,yBC3EI;ED4EJ,WCtFI;ADyER;AAgBE;EACE,sBCzFI;ED0FJ,WC3FI;AD6ER;AAiBE;EACE,yBAAA;EACA,SAAA;EACA,WChGI;ADiFR;AAkBE;EACE,sBCpGI;EDqGJ,cCnGG;EDoGH,2CAAA;AAhBJ;AAmBE;EACE,eAAA;EAEA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,cC3GI;ED4GJ,yBAAA;AAnBJ;AAsBE;EACE,cCtHG;EDuHH,yBAAA;AApBJ;AAuBE;EACE,yBAAA;EACA,gBAAA;EACA,cC7HG;ED8HH,+BAAA;EACA,8BC/HG;AD0GP;;AAwBA;EACE;IACE,4BAAA;IACA,6BAAA;EArBF;EAuBA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,eAAA;EArBF;AACF;AAuBA;EACE;IACE,uBAAA;EArBF;AACF;AAuBA;EACE;IACE,uBAAA;IACA,6BAAA;IACA,8BAAA;EArBF;AACF;AAuBA;EACE;IACE,0BAAA;EArBF;AACF;AAuBA;EACE;IACE,0BAAA;EArBF;AACF","sourcesContent":["@use \"src/styles/variables\" as vars;\n\n.Button {\n  border: 0;\n  border-radius: 30px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-weight: 500;\n\n  &.black-btn {\n    background-color: vars.$black;\n    color: vars.$white;\n  }\n\n  &.yellow-btn {\n    background-color: vars.$yellow;\n    color: vars.$black;\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n  }\n\n  &.blue-btn {\n    background-color: vars.$blue;\n    color: vars.$white;\n  }\n\n  &.red-btn {\n    background-color: vars.$red;\n    color: vars.$white;\n  }\n\n  &.red-disable-btn {\n    background-color: vars.$red;\n    color: vars.$white;\n    opacity: 0.5;\n    font-weight: 600;\n    border-radius: 5px;\n    height: 45px !important;\n    font-size: 15px !important;\n    margin-top: 0px;\n  }\n\n  &.warning-red-btn {\n    background-color: vars.$red;\n    color: vars.$white;\n    font-weight: 600;\n    border-radius: 5px;\n    height: 45px !important;\n    font-size: 15px !important;\n    margin-top: 0px;\n  }\n\n  &.link-blue-btn {\n    background-color: inherit;\n    font-weight: 500;\n    color: vars.$blue;\n  }\n\n  &.outline-grey-btn {\n    border: 1px solid vars.$grey3;\n    color: vars.$grey3;\n    background-color: inherit;\n  }\n\n  &.fullWidth {\n    width: 100%;\n  }\n\n  &.large-btn {\n    font-size: 20px;\n    height: 63px;\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  &.small-btn {\n    font-size: 14px;\n    height: 40px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  &.grey-btn {\n    background-color: vars.$grey1;\n    color: vars.$black;\n  }\n\n  &.dark-grey-btn {\n    background-color: vars.$grey4;\n    color: vars.$black;\n  }\n\n  &.white-btn {\n    background-color: vars.$white;\n    color: vars.$black;\n  }\n\n  &.white-link-btn {\n    background-color: inherit;\n    border: 0;\n    color: vars.$white;\n  }\n\n  &.white-blue-btn {\n    background-color: vars.$white;\n    color: vars.$blue;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n  }\n\n  &.extra-small-btn {\n    font-size: 10px;\n    //height: 20px;\n    padding-left: 7px;\n    padding-right: 7px;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  &.link-btn {\n    color: vars.$grey3;\n    background-color: inherit;\n  }\n\n  &.blue-link-btn {\n    color: vars.$blue;\n    background-color: inherit;\n  }\n\n  &.link-decoration-btn {\n    background-color: inherit;\n    font-weight: 500;\n    color: vars.$blue;\n    text-decoration-line: underline;\n    text-decoration-color: vars.$blue;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1200px) {\n  .Button.small-btn {\n    padding-left: 9px !important;\n    padding-right: 9px !important;\n  }\n  .Button.large-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: 12px;\n  }\n}\n@media screen and (max-width: 435px) {\n  Button.large-btn {\n    height: 48px !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .Button.small-btn {\n    height: 37px !important;\n    padding-left: 13px !important;\n    padding-right: 13px !important;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 820px) {\n  .Button.small-btn {\n    font-size: 13px !important;\n  }\n}\n@media screen and (min-width: 821px) and (max-width: 1200px) {\n  .Button.small-btn {\n    font-size: 11px !important;\n  }\n}\n","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
